module.exports = __webpack_public_path__ + "img/05.ad1b47e6.jpg";